import { AppLoader } from '@/components/AppLoader';
import type { DropzoneOptions } from '@/components/UploadTarget/types';
import { useCurrentUserContext } from '@/contexts';
import { getAuthUrl } from '@/features/canva/auth.lib';
import { useCanvaIntegrations } from '@/features/canva/hooks/useIntegrations';
import {
  useImagePicker,
  ImageSource,
} from '@/features/common/components/ImagePicker/useImagePicker';
import { useLauncherAction } from '@/hooks/useLauncher';
import { Icon, Link, Text } from '@/ui';
import { useAuthModal } from '../../components/AuthModal';

export const Dropzone = ({ onClick, onSelect }: DropzoneOptions) => {
  const { isAuthenticated } = useCurrentUserContext();
  const { open: openAuthModal } = useAuthModal();
  const { open: openImagePicker } = useImagePicker();
  const { data: integrations, isPending, refetch } = useCanvaIntegrations();
  const integration = integrations[0];

  const redirectToCanvaAuth = () => {
    window.location.href = getAuthUrl({ launch: 'canva-success' });
  };

  useLauncherAction('canva-connect', redirectToCanvaAuth);

  useLauncherAction('canva-success', () => {
    openImagePicker({ source: ImageSource.canva, onSelect });
  });

  if (isPending && isAuthenticated) {
    return <AppLoader />;
  }

  return (
    <>
      <Icon color="gray.400" icon="Image" size="64px" />
      <Text mt={{ base: '1', md: '4' }} mx="4">
        <Link
          colorScheme="dark"
          data-testid="dropzone-button-file"
          fontWeight="medium"
          textDecor="underline"
          onClick={onClick}
        >
          Choose a photo
        </Link>{' '}
        or{' '}
        {integration ? (
          <Link
            colorScheme="dark"
            fontWeight="medium"
            textDecor="underline"
            onClick={() => {
              openImagePicker({ source: ImageSource.canva, onSelect });
            }}
          >
            Import from Canva
          </Link>
        ) : !isAuthenticated ? (
          <Link
            colorScheme="dark"
            fontWeight="medium"
            textDecor="underline"
            onClick={() =>
              openAuthModal({
                launch: 'canva-connect',
                reason: 'canva-connect',
                onSuccess: async () => {
                  const { data: integrations = [] } = await refetch();
                  if (integrations.length === 0) {
                    redirectToCanvaAuth();
                  } else {
                    openImagePicker({
                      source: ImageSource.canva,
                      onSelect,
                    });
                  }
                },
              })
            }
          >
            Import from Canva
          </Link>
        ) : (
          <Link
            colorScheme="dark"
            fontWeight="medium"
            href={getAuthUrl({ launch: 'canva-success' })}
            textDecor="underline"
          >
            Connect to Canva
          </Link>
        )}
      </Text>
    </>
  );
};
